import { FaFacebook, FaLinkedin, FaTelegram } from "react-icons/fa";
import { MdLocationOn, MdPhone, MdEmail } from "react-icons/md";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-background bg-gradient-to-r from-midnigt to-shake text-white py-8 mt-auto relative overflow-hidden">
      {/* Grid Layout for Mobile Screens */}
      <div className="md:hidden grid grid-cols-4 px-2 gap-x-4 gap-y-4">
        {/* First Column - Services and Get In Touch */}
        <div className="mx-auto">
          {/* Services Section */}
          <div className="flex flex-col whitespace-nowrap mx-auto">
            <h3 className="text-xl sm:text-2xl font-['Catamaran'] mb-4">
              {t("home.footer.services")}
            </h3>
            <ul className="space-y-3 text-sm sm:text-md font-['Nunito Sans']">
              <li>
                <Link
                  to="/services/Cyber_Incident_Monitoring"
                  className="hover:text-primary"
                >
                  {t("home.our_services.service3.title")}
                </Link>
              </li>
              <li>
                <Link
                  to="/services/Cyber_Threat_Analysis"
                  className="hover:text-primary"
                >
                  {t("home.our_services.service4.title")}
                </Link>
              </li>
              <li>
                <Link
                  to="/services/SOC_as_a_Service"
                  className="hover:text-primary"
                >
                  {t("home.our_services.service6.title")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Get In Touch Section */}
          <div className="mt-8 flex flex-col whitespace-nowrap mx-auto">
            <h3 className="text-xl sm:text-2xl font-['Catamaran'] mb-4">
              {t("home.footer.get_in_touch")}
            </h3>
            <ul className="space-y-3 text-sm sm:text-md font-['Nunito Sans']">
              <li className="flex items-center gap-2">
                <MdLocationOn className="text-lg sm:text-xl" />
                <span>{t("home.footer.address")}</span>
              </li>
              <li className="flex items-center gap-2">
                <MdPhone className="text-lg sm:text-xl" />
                <span>933</span>
              </li>
              <li className="flex items-center gap-2">
                <MdEmail className="text-lg sm:text-xl" />
                <span>ethiocert@insa.gov.et</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Second Column - Follow Us */}
        <div className="sm:ml-52 ml-32 mx-auto">
          <h3 className="text-xl sm:text-2xl font-['Catamaran'] mb-4 flex flex-col">
            {t("home.footer.follow_us")}
          </h3>
          <div className="flex gap-4">
            <a
              href="https://facebook.com/ethiocert"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook className="text-xl sm:text-2xl hover:text-[#52a3c2]" />
            </a>
            <a
              href="https://linkedin.com/company/ethio-cert"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin className="text-xl sm:text-2xl hover:text-[#52a3c2]" />
            </a>
            <a
              href="https://t.me/Ethio_Cert_933"
              target="_blank"
              rel="noreferrer"
            >
              <FaTelegram className="text-xl sm:text-2xl hover:text-[#52a3c2]" />
            </a>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:grid md:grid-cols-4 lg:w-7xl w-8xl mx-auto lg:px-2 md:px-2">
        {/* Logo Section */}
        <div className="flex flex-col justify-center items-center md:items-start lg:ml-12 xl:ml-32">
          <h2 className="text-white text-3xl font-bold">Ethio-CERT</h2>
        </div>

        {/* Services Section */}
        <div className="relative xl:ml-40 lg:ml-auto md:mx-auto">
          <div className="absolute w-[5px] h-[25%] left-[-15px] top-2">
            <div className="h-1/2 bg-white"></div>
            <div className="h-1/2 bg-primary"></div>
          </div>
          <h3 className="text-2xl font-['Catamaran'] my-8">
            {t("home.footer.services")}
          </h3>
          <ul className="relative space-y-4 text-md font-['Nunito Sans'] whitespace-nowrap left-[-15px]">
            <li>
              <Link
                to="/services/Cyber_Incident_Monitoring"
                className="hover:text-primary"
              >
                {t("home.our_services.service3.title")}
              </Link>
            </li>
            <li>
              <Link
                to="/services/Cyber_Threat_Analysis"
                className="hover:text-primary"
              >
                {t("home.our_services.service4.title")}
              </Link>
            </li>
            <li>
              <Link
                to="/services/SOC_as_a_Service"
                className="hover:text-primary"
              >
                {t("home.our_services.service6.title")}
              </Link>
            </li>
          </ul>
        </div>

        {/* Get In Touch Section */}
        <div className="relative xl:ml-40 lg:ml-auto md:mx-auto">
          <div className="absolute w-[5px] h-[25%] left-[-15px] top-2">
            <div className="h-1/2 bg-white"></div>
            <div className="h-1/2 bg-primary"></div>
          </div>
          <h3 className="text-2xl font-['Catamaran'] my-8">
            {t("home.footer.get_in_touch")}
          </h3>
          <ul className="relative space-y-4 text-md font-['Nunito Sans'] whitespace-nowrap left-[-15px]">
            <li className="flex items-center gap-2">
              <MdLocationOn className="text-xl" />
              <span>{t("home.footer.address")}</span>
            </li>
            <li className="flex items-center gap-2">
              <MdPhone className="text-xl" />
              <span>933</span>
            </li>
            <li className="flex items-center gap-2">
              <MdEmail className="text-xl" />
              <span>ethiocert@insa.gov.et</span>
            </li>
          </ul>
        </div>

        {/* Follow Us Section */}
        <div className="relative xl:ml-40 lg:ml-auto md:mx-auto mt-2">
          <div className="absolute w-[5px] h-[25%] left-[-15px]">
            <div className="h-1/2 bg-white"></div>
            <div className="h-1/2 bg-primary"></div>
          </div>
          <h3 className="text-2xl font-['Catamaran'] my-4">
            {t("home.footer.follow_us")}
          </h3>
          <div className="flex gap-4">
            <a
              href="https://facebook.com/ethiocert"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebook className="text-2xl hover:text-[#52a3c2]" />
            </a>
            <a
              href="https://linkedin.com/company/ethio-cert"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin className="text-2xl hover:text-[#52a3c2]" />
            </a>
            <a
              href="https://t.me/Ethio_Cert_933"
              target="_blank"
              rel="noreferrer"
            >
              <FaTelegram className="text-2xl hover:text-[#52a3c2]" />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Text */}
      <div className="flex justify-center items-center text-center text-xs border-t border-gray-800 mt-4">
        <p className="mt-2">&copy; {new Date().getFullYear()} {t("home.footer.copyright")}</p>
      </div>
    </footer>
  );
};

export default Footer;